"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var isRolldown_exports = {};
__export(isRolldown_exports, {
  isRolldown: () => isRolldown
});
module.exports = __toCommonJS(isRolldown_exports);
var import_vite = require("vite");
var majorVersion = parseInt(import_vite.version.split(".")[0], 10);
function isRolldown() {
  return majorVersion >= 8;
}
//# sourceMappingURL=isRolldown.js.map
